import {ChangeDetectionStrategy, Component} from '@angular/core';
import {LoginFormComponent} from '@spartacus/user/account/components';

@Component({
    selector: 'aimo-logout',
    templateUrl: './aimo-logout.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AimoLogoutComponent extends LoginFormComponent  {

}
